import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid
} from '@material-ui/core'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import { InputFieldText } from '../InputFieldText'
import { InputSwitch } from '../InputSwitch'; // Importando seu componente customizado
import { useStyles } from './style'

const UserScheduleModal = ({
  open,
  onClose,
  onSaved,
  workSchedule,
  userId
}) => {
  const classes = useStyles()
  const [initialArray, setInitialArray] = useState([])
  const [loading, setLoading] = useState(false)

  // Estados para controlar a exibição dos campos de almoço
  const [lunchWeekEnabled, setLunchWeekEnabled] = useState(false)
  const [lunchSaturdayEnabled, setLunchSaturdayEnabled] = useState(false)
  const [lunchSundayEnabled, setLunchSundayEnabled] = useState(false)

  // Valores padrão para preenchimento rápido
  const [weekStartTime, setWeekStartTime] = useState('08:00')
  const [weekEndTime, setWeekEndTime] = useState('18:00')
  const [lunchStartTime, setLunchStartTime] = useState('12:00')
  const [lunchEndTime, setLunchEndTime] = useState('13:00')

  useEffect(() => {
    if (open) {
      const daysArray = [0, 1, 2, 3, 4, 5, 6].map(key => {
        const dayData = workSchedule?.days?.[key]
        return {
          checked: dayData ? !!dayData.enabled : false,
          startTimeA: dayData?.start || '08:00',
          endTimeA: dayData?.end || '18:00',
          startTimeB: dayData?.lunchStart || '',
          endTimeB: dayData?.lunchEnd || ''
        }
      })
      setInitialArray(daysArray)

      setLunchWeekEnabled(!!workSchedule?.days?.[1]?.lunchStart)
      setLunchSaturdayEnabled(!!workSchedule?.days?.[6]?.lunchStart)
      setLunchSundayEnabled(!!workSchedule?.days?.[0]?.lunchStart)
    }
  }, [open, workSchedule])

  const handleInternalSubmit = async values => {
    setLoading(true)
    const formattedDays = {}

    values.schedules.forEach((s, index) => {
      const isEnabled = !!s.checked
      formattedDays[index] = {
        enabled: isEnabled,
        start: isEnabled ? s.startTimeA : '',
        end: isEnabled ? s.endTimeA : '',
        lunchStart: isEnabled ? s.startTimeB : '',
        lunchEnd: isEnabled ? s.endTimeB : ''
      }
    })

    const payload = {
      workSchedule: {
        enabled: true,
        days: formattedDays
      }
    }

    try {
      if (!userId) throw new Error('ID do usuário não encontrado.')
      await api.put(`/users/${userId}`, payload)

      toast.success('Horários atualizados com sucesso!')
      if (onSaved) onSaved(payload.workSchedule)
      onClose()
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  const days = [
    { label: 'Dom', index: 0 },
    { label: 'Seg', index: 1 },
    { label: 'Ter', index: 2 },
    { label: 'Qua', index: 3 },
    { label: 'Qui', index: 4 },
    { label: 'Sex', index: 5 },
    { label: 'Sáb', index: 6 }
  ]

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: classes.dialogPaper }}
    >
      <DialogTitle className={classes.dialogTitle}>
        Horário de Expediente do Usuário
      </DialogTitle>

      <Formik
        enableReinitialize
        initialValues={{ schedules: initialArray }}
        onSubmit={handleInternalSubmit}
      >
        {({ values, setFieldValue, submitForm }) => {
          const showWeekTime = values.schedules?.some(
            (s, i) => s.checked && i >= 1 && i <= 5
          )
          const showSaturdayTime = values.schedules?.[6]?.checked
          const showSundayTime = values.schedules?.[0]?.checked

          const updateWeekLunch = (field, val) => {
            const news = values.schedules.map((s, i) =>
              s.checked && i >= 1 && i <= 5 ? { ...s, [field]: val } : s
            )
            setFieldValue('schedules', news)
          }

          const handleDayToggle = (dayIndex, isChecked) => {
            const newSchedules = [...values.schedules]
            const isWeekDay = dayIndex >= 1 && dayIndex <= 5

            if (!isChecked) {
              // Limpa todos os horários se o dia for desmarcado
              newSchedules[dayIndex] = {
                checked: false,
                startTimeA: '',
                endTimeA: '',
                startTimeB: '',
                endTimeB: ''
              }

              // Se for fim de semana, desativa também o toggle visual de almoço
              if (dayIndex === 0) setLunchSundayEnabled(false)
              if (dayIndex === 6) setLunchSaturdayEnabled(false)
            } else {
              // Se foi marcado, preenche com valores padrões da tela para não quebrar a UI
              newSchedules[dayIndex] = {
                checked: true,
                startTimeA: isWeekDay ? weekStartTime : '08:00',
                endTimeA: isWeekDay ? weekEndTime : '18:00',
                startTimeB: isWeekDay && lunchWeekEnabled ? lunchStartTime : '',
                endTimeB: isWeekDay && lunchWeekEnabled ? lunchEndTime : ''
              }
            }

            setFieldValue('schedules', newSchedules)
          }

          return (
            <Form>
              <DialogContent dividers>
                <Grid container className={classes.boxGrid}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.contentFormGroup}>
                      <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel
                          component="legend"
                          className={classes.formLabel}
                        >
                          Dias de Acesso
                        </FormLabel>
                        <FormGroup row>
                          {days.map(day => (
                            <FormControlLabel
                              key={day.index}
                              control={
                                <Checkbox
                                  checked={
                                    !!values.schedules[day.index]?.checked
                                  }
                                  onChange={e =>
                                    handleDayToggle(day.index, e.target.checked)
                                  }
                                  color="primary"
                                />
                              }
                              label={day.label}
                              className={classes.formLabel}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} className={classes.contentFormGrid}>
                      {/* BLOCO SEGUNDA A SEXTA */}
                      {showWeekTime && (
                        <div className={classes.boxShowWeekTime}>
                          <FormControl className={classes.formControl}>
                            <FormLabel
                              component="legend"
                              className={classes.formLabel}
                            >
                              Horário Durante a Semana
                            </FormLabel>
                            <div className={classes.inputWrapper}>
                              <InputFieldText
                                type="time"
                                value={weekStartTime}
                                onChange={e => {
                                  const val = e.target.value
                                  setWeekStartTime(val)
                                  const news = values.schedules.map((s, i) =>
                                    s.checked && i >= 1 && i <= 5
                                      ? { ...s, startTimeA: val }
                                      : s
                                  )
                                  setFieldValue('schedules', news)
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                              <span className={classes.textUntil}>até</span>
                              <InputFieldText
                                type="time"
                                value={weekEndTime}
                                onChange={e => {
                                  const val = e.target.value
                                  setWeekEndTime(val)
                                  const news = values.schedules.map((s, i) =>
                                    s.checked && i >= 1 && i <= 5
                                      ? { ...s, endTimeA: val }
                                      : s
                                  )
                                  setFieldValue('schedules', news)
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            </div>

                            <InputSwitch
                              label="Adicionar horário de almoço"
                              size="small"
                              checked={lunchWeekEnabled}
                              onChange={e => {
                                const isChecked = e.target.checked
                                setLunchWeekEnabled(isChecked)
                                const news = values.schedules.map((s, i) =>
                                  s.checked && i >= 1 && i <= 5
                                    ? {
                                        ...s,
                                        startTimeB: isChecked
                                          ? lunchStartTime
                                          : '',
                                        endTimeB: isChecked ? lunchEndTime : ''
                                      }
                                    : s
                                )
                                setFieldValue('schedules', news)
                              }}
                            />

                            {lunchWeekEnabled && (
                              <div className={classes.inputWrapper}>
                                <InputFieldText
                                  type="time"
                                  value={
                                    values.schedules[1]?.startTimeB ||
                                    lunchStartTime
                                  }
                                  onChange={e => {
                                    setLunchStartTime(e.target.value)
                                    updateWeekLunch(
                                      'startTimeB',
                                      e.target.value
                                    )
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                />
                                <span className={classes.textUntil}>até</span>
                                <InputFieldText
                                  type="time"
                                  value={
                                    values.schedules[1]?.endTimeB ||
                                    lunchEndTime
                                  }
                                  onChange={e => {
                                    setLunchEndTime(e.target.value)
                                    updateWeekLunch('endTimeB', e.target.value)
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </div>
                            )}
                          </FormControl>
                        </div>
                      )}

                      {/* BLOCO SÁBADO */}
                      {showSaturdayTime && (
                        <div className={classes.boxShowWeekTime}>
                          <FormControl className={classes.formControl}>
                            <FormLabel
                              component="legend"
                              className={classes.formLabel}
                            >
                              Sábado
                            </FormLabel>
                            <div className={classes.inputWrapper}>
                              <InputFieldText
                                type="time"
                                value={values.schedules[6].startTimeA}
                                onChange={e =>
                                  setFieldValue(
                                    'schedules[6].startTimeA',
                                    e.target.value
                                  )
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                              <span className={classes.textUntil}>até</span>
                              <InputFieldText
                                type="time"
                                value={values.schedules[6].endTimeA}
                                onChange={e =>
                                  setFieldValue(
                                    'schedules[6].endTimeA',
                                    e.target.value
                                  )
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            </div>

                            <InputSwitch
                              label="Adicionar horário de almoço"
                              size="small"
                              checked={lunchSaturdayEnabled}
                              onChange={e => {
                                const isChecked = e.target.checked
                                setLunchSaturdayEnabled(isChecked)
                                setFieldValue(
                                  'schedules[6].startTimeB',
                                  isChecked ? '12:00' : ''
                                )
                                setFieldValue(
                                  'schedules[6].endTimeB',
                                  isChecked ? '13:00' : ''
                                )
                              }}
                            />

                            {lunchSaturdayEnabled && (
                              <div className={classes.inputWrapper}>
                                <InputFieldText
                                  type="time"
                                  value={values.schedules[6].startTimeB}
                                  onChange={e =>
                                    setFieldValue(
                                      'schedules[6].startTimeB',
                                      e.target.value
                                    )
                                  }
                                  InputLabelProps={{ shrink: true }}
                                />
                                <span className={classes.textUntil}>até</span>
                                <InputFieldText
                                  type="time"
                                  value={values.schedules[6].endTimeB}
                                  onChange={e =>
                                    setFieldValue(
                                      'schedules[6].endTimeB',
                                      e.target.value
                                    )
                                  }
                                  InputLabelProps={{ shrink: true }}
                                />
                              </div>
                            )}
                          </FormControl>
                        </div>
                      )}

                      {/* BLOCO DOMINGO */}
                      {showSundayTime && (
                        <div className={classes.boxShowWeekTime}>
                          <FormControl className={classes.formControl}>
                            <FormLabel
                              component="legend"
                              className={classes.formLabel}
                            >
                              Domingo
                            </FormLabel>
                            <div className={classes.inputWrapper}>
                              <InputFieldText
                                type="time"
                                value={values.schedules[0].startTimeA}
                                onChange={e =>
                                  setFieldValue(
                                    'schedules[0].startTimeA',
                                    e.target.value
                                  )
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                              <span className={classes.textUntil}>até</span>
                              <InputFieldText
                                type="time"
                                value={values.schedules[0].endTimeA}
                                onChange={e =>
                                  setFieldValue(
                                    'schedules[0].endTimeA',
                                    e.target.value
                                  )
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            </div>

                            <InputSwitch
                              label="Adicionar horário de almoço"
                              size="small"
                              checked={lunchSundayEnabled}
                              onChange={e => {
                                const isChecked = e.target.checked
                                setLunchSundayEnabled(isChecked)
                                setFieldValue(
                                  'schedules[0].startTimeB',
                                  isChecked ? '12:00' : ''
                                )
                                setFieldValue(
                                  'schedules[0].endTimeB',
                                  isChecked ? '13:00' : ''
                                )
                              }}
                            />

                            {lunchSundayEnabled && (
                              <div className={classes.inputWrapper}>
                                <InputFieldText
                                  type="time"
                                  value={values.schedules[0].startTimeB}
                                  onChange={e =>
                                    setFieldValue(
                                      'schedules[0].startTimeB',
                                      e.target.value
                                    )
                                  }
                                  InputLabelProps={{ shrink: true }}
                                />
                                <span className={classes.textUntil}>até</span>
                                <InputFieldText
                                  type="time"
                                  value={values.schedules[0].endTimeB}
                                  onChange={e =>
                                    setFieldValue(
                                      'schedules[0].endTimeB',
                                      e.target.value
                                    )
                                  }
                                  InputLabelProps={{ shrink: true }}
                                />
                              </div>
                            )}
                          </FormControl>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <ButtonSecondary onClick={onClose} label="Cancelar" />
                <ButtonPrimary
                  loading={loading}
                  onClick={submitForm}
                  label="Salvar"
                />
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}

export default UserScheduleModal
